export const BadgeColor = {
  INFO: 'info',
  NEUTRAL: 'neutral',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
} as const;
export type BadgeColor = (typeof BadgeColor)[keyof typeof BadgeColor];
